import React from "react";
import Slider from "../Slider";
import Temp from "../Temp";

function Index() {
  return (
    <div>
      <Slider />
      <Temp />
    </div>
  );
}

export default Index;
